
export const parentReference = 'parent-checkbox';

export default class HierarchicalChildCheckbox {

    constructor(element) {
        this.element = element;
        this.parent = this.element.getAttribute('parent-checkbox');
    }

    check() {
        this.element.checked = true;
    }

    isChecked() {
        return this.element.checked;
    }
}
